export default __webpack_public_path__ + "static/media/BLE_OPEN_CLOSE.f246407a.png";